<template>
  <section>
    <section class="mb-2">
      <strong>Em uma escala de 0 a 10, o quanto você recomendaria a Ho Fácil Web para outras pessoas?</strong>
    </section>

    <section
      class='scale'
      :style='`background: ${scales.find((x) => x.scale === body.scale).color}`'
    >
      <span class='label'>{{ scales.find((x) => x.scale === body.scale).scale }}</span>
    </section>

    <section class="mt-2">
      <p class="mb-1"><strong>Me conte o porquê você me deu essa nota?</strong></p>
      <span v-if='body && body.justification'>{{body.justification}}</span>
      <strong v-else>-</strong>
    </section>

  </section>
</template>

<script>
export default {
  name: 'Recommendation',
  props: {
    body: { type: Object, required: true }
  },
  data() {
    return {
      scales: [
        {
          scale: 0,
          color: '#B72224;'
        },
        {
          scale: 1,
          color: '#D52029;'
        },
        {
          scale: 2,
          color: '#E95223;'
        },
        {
          scale: 3,
          color: '#EA6F22;'
        },
        {
          scale: 4,
          color: '#F6A726;'
        },
        {
          scale: 5,
          color: '#FDC729;'
        },
        {
          scale: 6,
          color: '#EBDB0A;'
        },
        {
          scale: 7,
          color: '#E5E044;'
        },
        {
          scale: 8,
          color: '#C2D234;'
        },
        {
          scale: 9,
          color: '#AEC93C;'
        },
        {
          scale: 10,
          color: '#66B44E;'
        }
      ]
    }
  }
}
</script>

<style lang='scss' scoped>
.scale {
  width: 50px;
  padding: 10px;
  border-radius: 4px;
  text-align: center;
  .label {
    color: #FFFFFF !important;
    font-style: normal;
    font-weight: 700;
  }
}
</style>
